<template>
  <div class="block-chuneng">
    <div class="wrap">
      <div class="cn">
        <img src="/static/images/svolt/nanwang/cn-icon-bj.png" />
        <span class="txt">
          <div class="number">{{ list[0].number }}</div>
          <div class="title">{{ list[0].title }}</div>
          <div class="unit">({{ list[0].unit }})</div>
        </span>
      </div>
      <div class="gf">
        <img src="/static/images/svolt/nanwang/gf-icon-bj.png" />
        <span class="txt">
          <div class="number">{{ list[1].number }}</div>
          <div class="title">{{ list[1].title }}</div>
          <div class="unit">({{ list[1].unit }})</div>
        </span>
      </div>
      <div class="cd">
        <img src="/static/images/svolt/nanwang/cd-icon-bj.png" />
        <span class="txt">
          <div class="number">{{ list[2].number }}</div>
          <div class="title">{{ list[2].title }}</div>
          <div class="unit">({{ list[2].unit }})</div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    height: {
      style: Number
    }
  },
  data() {
    return {
      list: [{ number: '500/1', title: '储能总容量', unit: 'kW/1MWh' }, { number: '15', title: '光伏总容量', unit: 'kW' }, { number: '120', title: '充电桩总容量', unit: 'kW' }]
    };
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss">
.block-chuneng {
  width: 428px;
  height: 147px;
  display: inline-block;
  background: url('/static/images/svolt/nanwang/block-guimo-bj.png') no-repeat;
  background-size: 100%;
  margin-left: -6px;
  margin-top: 5px;
  .wrap {
    display: flex;
    width: 100%;
    height: 129px;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 15px;
    img {
      width: 125px;
      height: 79px;
      position: relative;
      z-index: 0;
    }
    .txt {
      width: auto;
      display: inline-block;
      position: absolute;
      z-index: 2;
      left: 46px;
      top: -4px;
      text-align: center;
      .number {
        font-size: 28px;
        font-family: DINBold, DINAlternate;
        font-weight: bold;
        color: #19191a;
        background-clip: text;
        margin-bottom: 10px;
      }
      .title {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #7982A5;
        margin-bottom: 5px;
      }
      .unit {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #7982A5;
      }
    }
    .cn {
      position: relative;
    }
    .gf {
      position: relative;
    }
    .cd {
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/block-chuneng.vue